import React from "react";
import { ChevronDown } from "lucide-react";

export type CopyTradeExchange = "binance";

interface CopyTradeExchangeSelectProps {
  value: CopyTradeExchange;
  onChange: (value: CopyTradeExchange) => void;
  className?: string;
}

const exchangeOptions: {
  value: CopyTradeExchange | "coming_soon";
  label: string;
  disabled?: boolean;
}[] = [
  { value: "binance", label: "Binance" },
  { value: "coming_soon", label: "More exchanges (Coming soon)", disabled: true },
];

export const CopyTradeExchangeSelect: React.FC<CopyTradeExchangeSelectProps> = ({
  value,
  onChange,
  className = "",
}) => {
  return (
    <div className={`relative ${className}`}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as CopyTradeExchange)}
        className="appearance-none w-full bg-secondary border border-border rounded-lg px-4 py-2 pr-10 text-sm text-text-primary focus:outline-none focus:border-accent cursor-pointer hover:border-accent/50 transition-colors"
      >
        {exchangeOptions.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-secondary pointer-events-none" />
    </div>
  );
};
